import React, { useEffect, useState } from "react";
import { Button, Spin } from "antd";
import VendorOnboardingService from "../../../services/VendorOnboarding/vendorOnboarding-service";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import useEncryptData from "../../../utils/EncryptData";

const VendorDataPage = () => {
  const encryptData = useEncryptData();
  const [vendorData, setVendorData] = useState(null);
  const [loading, setLoading] = useState(true);
  const userDetails = useSelector(
    (state) => state.loginReducer.loginDetials.userDetails
  );
  const navigate = useNavigate();
  useEffect(() => {
    fetchVendorData();
  }, []);

  const fetchVendorData = async () => {
    try {
      const response = await VendorOnboardingService.getVendorUserDetails(
        userDetails.id
      );
      setVendorData(response.data?.responseData || {});
    } catch (error) {
      console.error("Failed to fetch vendor data:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="app-content content VendorOnboarding">
      <div className="content-wrapper">
        <div className="card shadow-sm rounded p-4 mb-4">
          <h4 className="card-title mb-3 fw-bold">Vendor Data</h4>
          <div className="card-body dark">
            <div className="row gy-3">
              <Field label="Email" value={vendorData?.email} />
              <Field label="Contact" value={vendorData?.phoneNumber} />
              <Field label="Vendor Company" value={vendorData?.vendorCompany} />
              <Field label="Organization" value={vendorData?.company} />
              <Field label="Vendor ID" value={vendorData?.vendorId} />
              <Field
                label="Created Date"
                value={
                  vendorData?.createdAt
                    ? dayjs(vendorData.createdAt).format("DD MMMM YYYY")
                    : "-"
                }
              />
            </div>

            <hr />

            <div className="pt-0 reset_save_btn justify-content-start">
              <Button
                className="save_btn mx-0"
                onClick={() =>
                  navigate(
                    `/VendorDetails?mode=${encodeURIComponent(
                      encryptData("view")
                    )}`
                  )
                }
              >
                View
              </Button>
              {vendorData?.canEdit && (
                <Button
                  className="reset_btn mx-3"
                  onClick={() =>
                    navigate(
                      `/VendorDetails?mode=${encodeURIComponent(
                        encryptData("edit")
                      )}`
                    )
                  }
                >
                  Edit
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Reusable field component
const Field = ({ label, value }) => (
  <div className="col-12 col-md-6 col-lg-4 col-xl-4">
    <div className="d-flex">
      <div className="fw-bold">{label}:</div>
      <div className="px-2">{value || "N/A"}</div>
    </div>
  </div>
);

export default VendorDataPage;
